import type { ReactNode } from 'react';
import { cn } from '../../../utils/cn';
import { SearchBar, type SearchBarProps } from '../SearchBar/SearchBar';
import styles from './FilterBar.module.css';

export interface FilterBarProps {
  /** When provided, a SearchBar is rendered. Pass undefined to omit it. */
  search?: SearchBarProps;
  children?: ReactNode;
  className?: string;
  ariaLabel?: string;
}

export function FilterBar({ search, children, className, ariaLabel = 'Filters' }: FilterBarProps) {
  return (
    <div role="region" aria-label={ariaLabel} className={cn(styles.bar, className)}>
      {search ? <SearchBar {...search} className={styles.search} /> : null}
      {children ? <div className={styles.controls}>{children}</div> : null}
    </div>
  );
}
